import { ValidatorFn, AbstractControl } from '@angular/forms';
import { setError } from './setError';

export function JsonValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        if (control.pristine) {
            return null;
        }

        let error = null;
        try {
            JSON.parse(control.value);
        } catch {
            error = { json: true };
            setError(control, error, 'json');
        }

        return error;
    };
}
